'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _enforceFunction2 = require('./internal/_enforceFunction');

var _enforceFunction3 = _interopRequireDefault(_enforceFunction2);

var _enforceInterval2 = require('./internal/_enforceInterval');

var _enforceInterval3 = _interopRequireDefault(_enforceInterval2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function throttle(interval, operation) {
  (0, _enforceInterval3.default)(interval);
  (0, _enforceFunction3.default)(operation);

  var lastArgs = void 0;
  var lastResult = void 0;
  var lastCall = 0;
  var timer = null;

  function cancel() {
    clearTimeout(timer);
    timer = null;
  }

  function runner() {
    lastCall = Date.now();
    cancel();
    lastResult = operation.apply(undefined, _toConsumableArray(lastArgs));
  }

  function throttled() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;
    if (Date.now() - lastCall >= interval) {
      runner();
    } else {
      timer = setTimeout(runner, interval);
    }
    return lastResult;
  }

  throttled.cancel = cancel;

  return throttled;
}

/**
 * Ensures `operation` is only called once every `interval` milliseconds.
 *
 * @param  {number} interval of milliseconds
 * @param  {Function} operation
 * @return {any} the most recent result of `operation`
 */
exports.default = (0, _curry2.default)(throttle);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/throttle.js
// module id = 390
// module chunks = 0 1